export default "__VITE_ASSET__hc51YhzD__ 100w";